import { render, staticRenderFns } from "./PatientDoctorSelect.vue?vue&type=template&id=28577ea0&"
import script from "./PatientDoctorSelect.vue?vue&type=script&lang=ts&"
export * from "./PatientDoctorSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports